import api from './_api';
import Vue from 'vue'

const postForm= async (context,payload) => {    
    let result=payload.payload
    let id=payload.id      
    try{        
        var response = await api.postForm(result,id)
        if (response) {              
            await context.dispatch('getAll');
            context.commit('COMPANY_SET_DUPLICATE', false)
            return response
        }
    }
    catch(error)  { 
        
        return null;
    };    
};
        
const getAll = async (context) => {
    try {
        var response = await api.fetchAll()                
        context.commit('COMPANY_SET_COMPANIES',response.data)        
        return response.data
    }
    catch(error) {                        
        return null
    };    
};

const getById = async (context,payload) => {
    try {        
        var response = await api.getById(payload)                
        context.commit('COMPANY_SET_COMPANY',response.data)           
        return response.data
    }
    catch(error) {                        
        return null
    };   
};
const deleteById = async (context,payload) => {
    
    try {             
        var response = await api.deleteById(payload)     
        await context.dispatch('getAll')           
        return response.data
    }
    catch(error) {   
        //alert(error)                          
        return null
    };    
};



export default {
  getAll,
  postForm,
  getById,
  deleteById
};

